import Swal, { SweetAlertType } from 'sweetalert2';

interface NotifyData {
  title: string;
  html: string;
  type: SweetAlertType;
}

export const notify = ({ title, html, type }: NotifyData) => {
  Swal({
    title: title,
    html: html,
    type: type
  }).then((result) => {});
};
